import React from "react";
import UsersListPanel from "./UsersListPanel";
import Modal from "./UsersModal";
import useUsersLoad from "./useUsersLoad";
import Select from "./UsersSelect";
import Swal from "sweetalert2";
import { Button, Form, Col, Row, OverlayTrigger, Tooltip } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import {
  tambahMarketing,
  tambahAksesMarketing,
  hapusAksesMarketing,
} from "stores";
import { getAllMarketing } from "stores";
import { getAllClient } from "stores";
import { getAllCabang } from "stores";
import { penempatanMarketing } from "stores";
import { editStatusMarketing } from "stores";
import moment from "moment";
import { resetPassword } from "stores";

function ListMarketing() {
  const dispatch = useDispatch();
  const listState = useUsersLoad(getAllMarketing, dispatch);
  const [selectedUser, setSelectedUser] = React.useState(null);
  const marketing = useSelector((state) => state.marketingReducer);
  const storeClient = useSelector((state) => state.clientReducer);
  const storeCabang = useSelector((state) => state.cabangReducer);
  const auth = useSelector((state) => state.authReducer);

  const [salesMarketing, setSalesMarketing] = React.useState(false);
  const [modalPenempatan, setModalPenempatan] = React.useState(false);
  const [modalEdit, setModalEdit] = React.useState(false);
  const [modalDetail, setModalDetail] = React.useState(false);
  const [modalTambahAkses, setModalTambahAkses] = React.useState(false);
  const [modalUbahPenempatan, setModalUbahPenempatan] = React.useState(false);
  const [pilihClient, setPilihClient] = React.useState(null);
  const [pilihRole, setPilihRole] = React.useState(null);
  const [role, setRole] = React.useState("");
  const [nik, setNik] = React.useState("");
  const [nama, setNama] = React.useState("");
  const [nopeg, setNopeg] = React.useState("");
  const [listClient, setListClient] = React.useState([]);
  const [listMarketing, setListMarketing] = React.useState([]);
  const [idClient, setIdClient] = React.useState("");
  const [pilihCabang, setPilihCabang] = React.useState(null);
  const [listCabang, setListCabang] = React.useState([]);
  const [idCabang, setIdCabang] = React.useState(null);
  const [idMarketing, setIdMarketing] = React.useState("");
  const [status, setStatus] = React.useState("");

  const [loading, setLoading] = React.useState(false);
  const [pilihAkses, setPilihAkses] = React.useState("");
  const [aksesUser, setAksesUser] = React.useState([]);

  const handleNikChange = (e) => {
    const inputNik = e.target.value;
    const formattedNik = inputNik.slice(0, 16);
    setNik(formattedNik);
  };

  const remainingDigits = 16 - nik.length;

  const submitMarketing = () => {
    if (nik.length < 16) {
      Swal.fire({
        title: "NIK harus 16 digit !!",
        icon: "warning",
      });
      return;
    }
    tambahMarketing({
      nik: nik,
      nama: nama,
      nopeg: nopeg,
      role: role,
      idClient: idClient,
    })
      .then((response) => {
        if (response.data.status === 200) {
          Swal.fire({
            position: "center",
            icon: "success",
            title: response.data.message,
            showConfirmButton: false,
            timer: 1000,
          });
          handleModalClose();
          getAllMarketing(dispatch, { idClient: "" });
          // setIdClient("");
          // setPilihClient("");
          // setPilihRole("");
        } else if (response.data.status === 400) {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: response.data.message,
          });
        } else {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: response.data.message,
          });
        }
      })
      .catch((error) => {
        console.log("ERRORRRR", error);
      });
  };

  const checkStatus = () => {
    if (status.value === undefined || status === "") {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Status wajib diisi !",
      });
    } else {
      submitEditStatus();
    }
  };

  const submitEditStatus = () => {
    setLoading(true);
    editStatusMarketing({
      idMarketing: idMarketing,
      status: status.value,
    })
      .then((response) => {
        setLoading(false);
        if (response.data.status === 200) {
          Swal.fire({
            position: "center",
            icon: "success",
            title: response.data.message,
            showConfirmButton: false,
            timer: 1000,
          });
          getAllMarketing(dispatch, { idClient: "" });
          setModalEdit(false);
          setStatus("");
        } else if (response.data.status === 400) {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: response.data.message,
          });
        } else {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: response.data.message,
          });
        }
      })
      .catch((error) => {
        setLoading(false);
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: error.message,
        });
      });
  };

  const submitPenempatan = () => {
    if (pilihCabang === null) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Pemilihan Cabang tidak boleh kosong",
      });
    } else {
      penempatanMarketing({
        idMarketing: idMarketing,
        idCabang: idCabang,
      }).then((response) => {
        if (response.data.status === 200) {
          Swal.fire({
            position: "center",
            icon: "success",
            title: response.data.message,
            showConfirmButton: false,
            timer: 1000,
          });
          handleModalClose();
          setIdCabang("");
          setPilihCabang("");
          getAllMarketing(dispatch, { idClient: "" });
        } else if (response.status === 400) {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: response.data.message,
          });
        }
      });
    }
  };

  const submitUbahPenempatan = () => {
    if (pilihCabang === null) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Pemilihan Cabang tidak boleh kosong",
      });
    } else {
      penempatanMarketing({
        idMarketing: idMarketing,
        idCabang: idCabang,
      }).then((response) => {
        if (response.data.status === 200) {
          Swal.fire({
            position: "center",
            icon: "success",
            title: response.data.message,
            showConfirmButton: false,
            timer: 1500,
          });
          handleModalClose();
          setIdCabang(null);
          setPilihCabang(null);
          getAllMarketing(dispatch, { idClient: "" });
        } else if (response.status === 400) {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: response.data.message,
          });
        }
      });
    }
  };

  const handleModalClose = () => {
    setPilihCabang(null);
    setIdCabang(null);
    setPilihRole(null);
    setPilihAkses(null);
    setRole("");
    setPilihClient(null);
    setSalesMarketing(false);
    setModalPenempatan(false);
    setModalUbahPenempatan(false);
    setModalTambahAkses(false);
    setNik("");
    setNopeg("");
    setNama("");
  };

  const submitTambahAksesMarketing = () => {
    if (!pilihAkses) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Pemilihan akses tidak boleh kosong",
      });
    } else {
      tambahAksesMarketing({
        idMarketing: idMarketing,
        akses: pilihAkses.value,
      }).then((response) => {
        if (response.data.status === 200) {
          Swal.fire({
            position: "center",
            icon: "success",
            title: response.data.message,
            showConfirmButton: false,
            timer: 1000,
          });
          handleModalClose();
          // setIdCabang("");
          // setPilihCabang("");
          getAllMarketing(dispatch, { idClient: "" });
        } else if (response.data.status === 400) {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: response.data.message,
          });
        }
      });
    }
  };

  React.useEffect(() => {
    let tmp =
      marketing.listMarketing &&
      marketing.listMarketing.map((val) => {
        const ubahPenempatan = val.penempatan != "";
        return {
          ...val,
          action: (
            <>
              <div style={{ display: "flex", gap: "8px", justifyContent: "center" }}>
                <OverlayTrigger
                  placement="top"
                  overlay={<Tooltip>{ubahPenempatan ? "Ubah Penempatan" : "Penempatan Marketing"}</Tooltip>}
                >
                  <Button
                    aria-label={ubahPenempatan ? "Ubah Penempatan" : "Penempatan Marketing"}
                    title={ubahPenempatan ? "Ubah Penempatan" : "Penempatan Marketing"}
                    disabled={!ubahPenempatan && val.status !== "aktif"}
                    variant="light"
                    style={{
                      padding: "8px",
                      borderRadius: "8px",
                      backgroundColor: (!ubahPenempatan && val.status !== "aktif") ? "#F1F5F9" : (ubahPenempatan ? "#FFFBEB" : "#EFF6FF"),
                      color: (!ubahPenempatan && val.status !== "aktif") ? "#94A3B8" : (ubahPenempatan ? "#D97706" : "#3B82F6"),
                      border: "none",
                      boxShadow: (!ubahPenempatan && val.status !== "aktif") ? "none" : "0 2px 4px rgba(0,0,0,0.05)",
                      transition: "all 0.2s",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: "36px",
                      height: "36px",
                      cursor: (!ubahPenempatan && val.status !== "aktif") ? "not-allowed" : "pointer",
                    }}
                    onMouseEnter={(e) => {
                      if (!(!ubahPenempatan && val.status !== "aktif")) {
                        e.currentTarget.style.backgroundColor = ubahPenempatan ? "#D97706" : "#3B82F6";
                        e.currentTarget.style.color = "#FFFFFF";
                      }
                    }}
                    onMouseLeave={(e) => {
                      if (!(!ubahPenempatan && val.status !== "aktif")) {
                        e.currentTarget.style.backgroundColor = ubahPenempatan ? "#FFFBEB" : "#EFF6FF";
                        e.currentTarget.style.color = ubahPenempatan ? "#D97706" : "#3B82F6";
                      }
                    }}
                    onClick={() => {
                      setSelectedUser(val);
                      setIdMarketing(val._id);
                      setPilihCabang(null);
                      setIdCabang(null);
                      getAllCabang(dispatch, { idClient: val.idClient });
                      if (ubahPenempatan) {
                        setModalUbahPenempatan(!modalUbahPenempatan);
                      } else {
                        setModalPenempatan(!modalPenempatan);
                      }
                    }}
                  >
                    <i className="fas fa-map-marked-alt"></i>
                  </Button>
                </OverlayTrigger>

                <OverlayTrigger
                  placement="top"
                  overlay={<Tooltip>Tambah Akses</Tooltip>}
                >
                  <Button aria-label="Tambah Akses" title="Tambah Akses"
                    variant="light"
                    style={{
                      padding: "8px",
                      borderRadius: "8px",
                      backgroundColor: "#FDF4FF",
                      color: "#C026D3",
                      border: "none",
                      boxShadow: "0 2px 4px rgba(0,0,0,0.05)",
                      transition: "all 0.2s",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: "36px",
                      height: "36px",
                      cursor: "pointer",
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.backgroundColor = "#C026D3";
                      e.currentTarget.style.color = "#FFFFFF";
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.backgroundColor = "#FDF4FF";
                      e.currentTarget.style.color = "#C026D3";
                    }}
                    onClick={() => {
                      setSelectedUser(val);
                      setIdMarketing(val._id);
                      setPilihAkses("");
                      setModalTambahAkses(true);
                      setAksesUser(val.akses);
                    }}
                  >
                    <i className="fas fa-user-cog"></i>
                  </Button>
                </OverlayTrigger>

                <OverlayTrigger
                  placement="top"
                  overlay={<Tooltip>Edit Status</Tooltip>}
                >
                  <Button aria-label="Edit Status" title="Edit Status"
                    variant="light"
                    style={{
                      padding: "8px",
                      borderRadius: "8px",
                      backgroundColor: "#F0FDF4",
                      color: "#16A34A",
                      border: "none",
                      boxShadow: "0 2px 4px rgba(0,0,0,0.05)",
                      transition: "all 0.2s",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: "36px",
                      height: "36px",
                      cursor: "pointer",
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.backgroundColor = "#16A34A";
                      e.currentTarget.style.color = "#FFFFFF";
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.backgroundColor = "#F0FDF4";
                      e.currentTarget.style.color = "#16A34A";
                    }}
                    onClick={() => {
                      setSelectedUser(val);
                      setIdMarketing(val._id);
                      setStatus("");
                      setModalEdit(true);
                    }}
                  >
                    <i className="fas fa-edit"></i>
                  </Button>
                </OverlayTrigger>

                <OverlayTrigger
                  placement="top"
                  overlay={<Tooltip>Reset Password</Tooltip>}
                >
                  <Button aria-label="Reset Password" title="Reset Password"
                    variant="light"
                    style={{
                      padding: "8px",
                      borderRadius: "8px",
                      backgroundColor: "#FEF2F2",
                      color: "#EF4444",
                      border: "none",
                      boxShadow: "0 2px 4px rgba(0,0,0,0.05)",
                      transition: "all 0.2s",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: "36px",
                      height: "36px"
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.backgroundColor = "#EF4444";
                      e.currentTarget.style.color = "#FFFFFF";
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.backgroundColor = "#FEF2F2";
                      e.currentTarget.style.color = "#EF4444";
                    }}
                    onClick={async () => {
                      const result = await Swal.fire({
                        title: "Reset Password",
                        text: `Apakah Anda yakin ingin mereset password pengguna ${val.nama}?`,
                        icon: "warning",
                        showCancelButton: true,
                        confirmButtonColor: "#3085d6",
                        cancelButtonColor: "#d33",
                        confirmButtonText: "Ya, Reset Password!",
                      });

                      if (result.isConfirmed) {
                        try {
                          const response = await resetPassword({
                            idUser: val._id,
                            role: val.role,
                          });

                          Swal.fire({
                            title: "Sukses",
                            text: response.data.message,
                            icon: "success",
                          });
                        } catch (error) {
                          Swal.fire({
                            title: "Error",
                            text: error.response.data.message,
                            icon: "error",
                          });
                        }
                      }
                    }}
                  >
                    <i className="fas fa-redo-alt"></i>
                  </Button>
                </OverlayTrigger>
              </div>
            </>
          ),
        };
      });
    setListMarketing(tmp);
  }, [marketing.listMarketing]);

  React.useEffect(() => {
    let tmp = [
      {
        value: "",
        isDisabled: true,
      },
    ];
    storeCabang.listCabang &&
      storeCabang.listCabang.map((val) => {
        tmp.push({
          value: val._id,
          label: val.namaCabang,
        });
      });

    setListCabang(tmp);
  }, [storeCabang.listCabang]);

  React.useEffect(() => {
    let tmp = [
      {
        value: "",
        isDisabled: true,
      },
    ];
    storeClient.listClient &&
      storeClient.listClient.map((val) => {
        tmp.push({
          value: val._id,
          label: val.namaClient,
        });
      });

    setListClient(tmp);
  }, [storeClient.listClient]);

  const getStatusUser = (statusUser) => {
    switch (statusUser) {
      case "tidak aktif":
        return {
          backgroundColor: "#FEE2E2",
          textColor: "#DC2626",
          icon: "fas fa-times-circle"
        };
      case "aktif":
        return {
          backgroundColor: "#DCFCE7",
          textColor: "#16A34A",
          icon: "fas fa-check-circle"
        };
      default:
        return {
          backgroundColor: "#F1F5F9",
          textColor: "#64748B",
          icon: "fas fa-info-circle"
        };
    }
  };

  const colSalesMarketing = [
    {
      name: "No",
      width: "100px",
      center: true,
      selector: (row, index) => index + 1,
    },
    {
      name: "Kode User",
      minWidth: "200px",
      center: true,
      selector: (row) => row.kodeUser,
    },
    {
      name: "No Karyawan",
      minWidth: "200px",
      center: true,
      selector: (row) => row.nopeg,
    },
    {
      name: "Nama",
      minWidth: "200px",
      center: true,
      selector: (row) => row.nama,
    },
    {
      name: "Jabatan",
      minWidth: "200px",
      center: true,
      selector: (row) =>
        row.role === "marketing" ? "Sales Marketing" : "Direct Sales Marketing",
    },
    {
      name: "BPD",
      minWidth: "200px",
      center: true,
      omit: auth.role === "super admin" ? false : true,
      selector: (row) =>
        !row.penempatan?.length ? (
          <div style={{ fontWeight: "bold" }}>Belum Penempatan</div>
        ) : (
          row.penempatan?.[0]?.namaClient
        ),
    },
    {
      name: "Cabang",
      minWidth: "250px",
      center: true,
      selector: (row) =>
        !row.penempatan?.length ? (
          <div style={{ fontWeight: "bold" }}>Belum Penempatan</div>
        ) : (
          row.penempatan?.[0]?.namaCabang
        ),
    },
    {
      name: "Login Terakhir",
      minWidth: "300px",
      center: true,
      selector: (row) =>
        !row.loginDate ? "-" : moment(row.loginDate).format("DD-MM-YYYY hh:mm"),
    },
    {
      name: "Akses",
      minWidth: "250px",
      center: true,
      selector: (row) =>
        !row.akses || row.akses.length === 0 ? (
          <div style={{ fontWeight: "bold", color: "red" }}>
            Belum Memiliki Akses
          </div>
        ) : (
          <div
            style={{
              fontWeight: "bold",
              color: "blue",
              textTransform: "capitalize",
            }}
          >
            {row.akses.join(", ")}
          </div>
        ),
    },
    {
      name: "Status",
      minWidth: "150px",
      center: true,
      // selector: (row) => (row.status === "aktif" ? "Aktif" : "Tidak Aktif"),
      selector: (row) => row.status,
      cell: (row) => {
        const statusStyle = getStatusUser(row.status);
        const tampilanLabel = row.status === "aktif" ? "Aktif" : "Tidak Aktif";

        return (
          <div
            style={{
              display: "inline-flex",
              alignItems: "center",
              gap: "6px",
              fontWeight: "600",
              backgroundColor: statusStyle.backgroundColor,
              color: statusStyle.textColor,
              padding: "6px 12px",
              borderRadius: "20px",
              fontSize: "12px",
              boxShadow: "0 1px 2px rgba(0,0,0,0.05)"
            }}
          >
            <i className={statusStyle.icon}></i>
            {tampilanLabel}
          </div>
        );
      },
    },
    {
      name: "Aksi",
      minWidth: "300px",
      omit: auth.role === "super admin" || auth.role === "admin" ? false : true,
      center: true,
      selector: (row) => row.action,
    },
  ];

  const listAkses = [
    { value: "", isDisabled: true },
    { label: "Konsumtif", value: "konsumtif" },
    { label: "Produktif", value: "produktif" },
  ];

  React.useEffect(() => { getAllClient(dispatch); }, [dispatch]);

  return (
    <>
      <Modal
        size="md"
        show={modalUbahPenempatan}
        onHide={() => {
          handleModalClose();
          setModalUbahPenempatan(false);
        }}
        centered
        contentClassName="luxury-modal"
        selectedUser={selectedUser}
      >
        <>
          <Modal.Header style={{ borderBottom: "1px solid #E2E8F0", padding: "20px 24px", backgroundColor: "#F8FAFC" }}>
            <Modal.Title style={{ color: "#1E293B", fontWeight: "700", fontSize: "18px", margin: 0, display: "flex", alignItems: "center", gap: "10px" }}>
              <div style={{ backgroundColor: "#FFFBEB", padding: "8px", borderRadius: "10px", color: "#D97706", display: "flex" }}>
                <i className="fas fa-exchange-alt"></i>
              </div>
              Form Ubah Penempatan Marketing
            </Modal.Title>
            <button aria-label="Tutup dialog" type="button" className="close" onClick={() => setModalUbahPenempatan(false)} style={{ color: "#64748B", opacity: 1, fontSize: "24px" }}>&times;</button>
          </Modal.Header>

          <Modal.Body style={{ padding: "24px" }}>
            <Form>
              <Form.Group>
                <label style={{ color: "#475569", fontWeight: "600", fontSize: "14px", marginBottom: "8px" }}>Pilih Cabang</label>
                <Select
                  classNamePrefix="react-select"
                  value={pilihCabang}
                  onChange={(value) => {
                    setPilihCabang(value);
                    setIdCabang(value.value);
                  }}
                  options={listCabang}
                  placeholder="Pilih Cabang..."
                  styles={{
                    control: (base) => ({
                      ...base,
                      borderRadius: "10px",
                      borderColor: "#E2E8F0",
                      padding: "2px",
                      boxShadow: "none",
                      "&:hover": { borderColor: "#D97706" }
                    })
                  }}
                />
              </Form.Group>
            </Form>
          </Modal.Body>

          <Modal.Footer style={{ borderTop: "1px solid #E2E8F0", padding: "16px 24px", backgroundColor: "#F8FAFC" }}>
            <Button
              variant="light"
              onClick={() => setModalUbahPenempatan(false)}
              style={{ borderRadius: "8px", fontWeight: "600", padding: "10px 20px", color: "#64748B", border: "1px solid #E2E8F0" }}
            >
              Batal
            </Button>
            <Button
              onClick={submitUbahPenempatan}
              style={{ borderRadius: "8px", fontWeight: "600", padding: "10px 20px", backgroundColor: "#D97706", border: "none", boxShadow: "0 4px 6px rgba(217, 119, 6, 0.2)", color: "white" }}
            >
              Simpan Perubahan
            </Button>
          </Modal.Footer>
        </>
      </Modal>

      <Modal
        size="md"
        show={modalPenempatan}
        onHide={() => {
          handleModalClose();
          setModalPenempatan(false);
        }}
        centered
        contentClassName="luxury-modal"
        selectedUser={selectedUser}
      >
        <>
          <Modal.Header style={{ borderBottom: "1px solid #E2E8F0", padding: "20px 24px", backgroundColor: "#F8FAFC" }}>
            <Modal.Title style={{ color: "#1E293B", fontWeight: "700", fontSize: "18px", margin: 0, display: "flex", alignItems: "center", gap: "10px" }}>
              <div style={{ backgroundColor: "#EFF6FF", padding: "8px", borderRadius: "10px", color: "#3B82F6", display: "flex" }}>
                <i className="fas fa-map-marker-alt"></i>
              </div>
              Form Penempatan Marketing
            </Modal.Title>
            <button aria-label="Tutup dialog" type="button" className="close" onClick={() => setModalPenempatan(false)} style={{ color: "#64748B", opacity: 1, fontSize: "24px" }}>&times;</button>
          </Modal.Header>

          <Modal.Body style={{ padding: "24px" }}>
            <Form>
              <Form.Group>
                <label style={{ color: "#475569", fontWeight: "600", fontSize: "14px", marginBottom: "8px" }}>Pilih Cabang</label>
                <Select
                  classNamePrefix="react-select"
                  placeholder="Pilih Cabang..."
                  value={pilihCabang}
                  onChange={(value) => {
                    setPilihCabang(value);
                    setIdCabang(value.value);
                  }}
                  options={listCabang}
                  styles={{
                    control: (base) => ({
                      ...base,
                      borderRadius: "10px",
                      borderColor: "#E2E8F0",
                      padding: "2px",
                      boxShadow: "none",
                      "&:hover": { borderColor: "#3B82F6" }
                    })
                  }}
                />
              </Form.Group>
            </Form>
          </Modal.Body>

          <Modal.Footer style={{ borderTop: "1px solid #E2E8F0", padding: "16px 24px", backgroundColor: "#F8FAFC" }}>
            <Button
              variant="light"
              onClick={() => setModalPenempatan(false)}
              style={{ borderRadius: "8px", fontWeight: "600", padding: "10px 20px", color: "#64748B", border: "1px solid #E2E8F0" }}
            >
              Batal
            </Button>
            <Button
              onClick={submitPenempatan}
              style={{ borderRadius: "8px", fontWeight: "600", padding: "10px 20px", backgroundColor: "#3B82F6", border: "none", boxShadow: "0 4px 6px rgba(59, 130, 246, 0.2)", color: "white" }}
            >
              Simpan Penempatan
            </Button>
          </Modal.Footer>
        </>
      </Modal>

      <Modal
        size="md"
        show={modalEdit}
        onHide={() => {
          setStatus("");
          setModalEdit(false);
        }}
        centered
        contentClassName="luxury-modal"
        selectedUser={selectedUser}
      >
        <>
          <Modal.Header style={{ borderBottom: "1px solid #E2E8F0", padding: "20px 24px", backgroundColor: "#F8FAFC" }}>
            <Modal.Title style={{ color: "#1E293B", fontWeight: "700", fontSize: "18px", margin: 0, display: "flex", alignItems: "center", gap: "10px" }}>
              <div style={{ backgroundColor: "#E0F2FE", padding: "8px", borderRadius: "10px", color: "#0EA5E9", display: "flex" }}>
                <i className="fas fa-edit"></i>
              </div>
              Edit Status Marketing
            </Modal.Title>
            <button aria-label="Tutup dialog" type="button" className="close" onClick={() => setModalEdit(false)} style={{ color: "#64748B", opacity: 1, fontSize: "24px" }}>&times;</button>
          </Modal.Header>

          <Modal.Body style={{ padding: "24px" }}>
            <Form>
              <Form.Group>
                <label style={{ color: "#475569", fontWeight: "600", fontSize: "14px", marginBottom: "8px" }}>Pilih Status</label>
                <Select
                  classNamePrefix="react-select"
                  value={status}
                  onChange={(selectedOption) => setStatus(selectedOption)}
                  options={[
                    { value: "true", label: "Aktif" },
                    { value: "false", label: "Tidak Aktif" },
                  ]}
                  placeholder="Pilih status aktif/tidak aktif"
                  styles={{
                    control: (base) => ({
                      ...base,
                      borderRadius: "10px",
                      borderColor: "#E2E8F0",
                      padding: "2px",
                      boxShadow: "none",
                      "&:hover": { borderColor: "#0EA5E9" }
                    })
                  }}
                />
              </Form.Group>
            </Form>
          </Modal.Body>

          <Modal.Footer style={{ borderTop: "1px solid #E2E8F0", padding: "16px 24px", backgroundColor: "#F8FAFC" }}>
            <Button
              variant="light"
              onClick={() => setModalEdit(false)}
              style={{ borderRadius: "8px", fontWeight: "600", padding: "10px 20px", color: "#64748B", border: "1px solid #E2E8F0" }}
            >
              Batal
            </Button>
            <Button
              variant="primary"
              onClick={checkStatus}
              style={{ borderRadius: "8px", fontWeight: "600", padding: "10px 20px", backgroundColor: "#0EA5E9", border: "none", boxShadow: "0 4px 6px rgba(14, 165, 233, 0.2)", color: "white" }}
            >
              Simpan Perubahan
            </Button>
          </Modal.Footer>
        </>
      </Modal>

      <UsersListPanel title="Sales Marketing" description="Pantau tim pemasaran, penempatan, akses, dan aktivitas login."
        data={listMarketing} columns={colSalesMarketing} {...listState}
        addLabel="Tambah Marketing" onAdd={(auth.role === "super admin" || auth.role === "admin") ? () => setSalesMarketing(true) : undefined} />

      <Modal
        size="lg"
        show={salesMarketing}
        onHide={() => {
          handleModalClose();
          setSalesMarketing(false);
        }}
        centered
        contentClassName="luxury-modal"
        selectedUser={null}
      >
        <>
          <Modal.Header style={{ borderBottom: "1px solid #E2E8F0", padding: "20px 24px", backgroundColor: "#F8FAFC" }}>
            <Modal.Title style={{ color: "#1E293B", fontWeight: "700", fontSize: "18px", margin: 0, display: "flex", alignItems: "center", gap: "10px" }}>
              <div style={{ backgroundColor: "#E0F2FE", padding: "8px", borderRadius: "10px", color: "#0EA5E9", display: "flex" }}>
                <i className="fas fa-user-plus"></i>
              </div>
              Form Tambah Marketing
            </Modal.Title>
            <button aria-label="Tutup dialog" type="button" className="close" onClick={() => { handleModalClose(); setSalesMarketing(false); }} style={{ color: "#64748B", opacity: 1, fontSize: "24px" }}>&times;</button>
          </Modal.Header>
          <Modal.Body style={{ padding: "24px" }}>
            <Form>
              <Row>
                <Col md={6}>
                  <Form.Group className="mb-4">
                    <label style={{ color: "#475569", fontWeight: "600", fontSize: "14px", marginBottom: "8px" }}>NIK</label>
                    <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                      <Form.Control
                        onChange={handleNikChange}
                        value={nik}
                        type="text"
                        placeholder="Masukkan 16 digit NIK"
                        style={{ borderRadius: "10px", padding: "12px 16px", border: "1px solid #E2E8F0", flex: 1 }}
                      />
                      <span style={{ fontSize: "12px", fontWeight: "600", color: remainingDigits === 0 ? "#16A34A" : "#94A3B8", backgroundColor: remainingDigits === 0 ? "#DCFCE7" : "#F1F5F9", padding: "4px 8px", borderRadius: "20px" }}>
                        {remainingDigits} digit
                      </span>
                    </div>
                  </Form.Group>
                </Col>
                <Col md={6}>
                  <Form.Group className="mb-4">
                    <label style={{ color: "#475569", fontWeight: "600", fontSize: "14px", marginBottom: "8px" }}>Nama Lengkap</label>
                    <Form.Control
                      onChange={(e) => setNama(e.target.value)}
                      placeholder="Masukkan nama lengkap"
                      type="text"
                      style={{ borderRadius: "10px", padding: "12px 16px", border: "1px solid #E2E8F0" }}
                    />
                  </Form.Group>
                </Col>
                <Col md={6}>
                  <Form.Group className="mb-4">
                    <label style={{ color: "#475569", fontWeight: "600", fontSize: "14px", marginBottom: "8px" }}>No Karyawan</label>
                    <Form.Control
                      onChange={(e) => setNopeg(e.target.value)}
                      placeholder="Masukkan No Karyawan"
                      type="text"
                      style={{ borderRadius: "10px", padding: "12px 16px", border: "1px solid #E2E8F0" }}
                    />
                  </Form.Group>
                </Col>
                <Col md={6}>
                  <Form.Group className="mb-4">
                    <label style={{ color: "#475569", fontWeight: "600", fontSize: "14px", marginBottom: "8px" }}>Pilih Role</label>
                    <Select
                      classNamePrefix="react-select"
                      value={pilihRole}
                      onChange={(value) => {
                        setPilihRole(value);
                        setRole(value.value);
                      }}
                      options={[
                        { value: "marketing", label: "Sales Marketing" },
                        { value: "direct marketing", label: "Direct Marketing" },
                      ]}
                      placeholder="Pilih Role..."
                      styles={{
                        control: (base) => ({
                          ...base,
                          borderRadius: "10px",
                          borderColor: "#E2E8F0",
                          padding: "4px",
                          boxShadow: "none",
                          "&:hover": { borderColor: "#0EA5E9" }
                        })
                      }}
                    />
                  </Form.Group>
                </Col>
                {auth.role === "super admin" && (
                  <Col md={12}>
                    <Form.Group className="mb-4">
                      <label style={{ color: "#475569", fontWeight: "600", fontSize: "14px", marginBottom: "8px" }}>Pilih Client (BPD)</label>
                      <Select
                        classNamePrefix="react-select"
                        value={pilihClient}
                        onChange={(value) => {
                          setPilihClient(value);
                          setIdClient(value.value);
                        }}
                        options={listClient}
                        placeholder="Pilih BPD..."
                        styles={{
                          control: (base) => ({
                            ...base,
                            borderRadius: "10px",
                            borderColor: "#E2E8F0",
                            padding: "4px",
                            boxShadow: "none",
                            "&:hover": { borderColor: "#0EA5E9" }
                          })
                        }}
                      />
                    </Form.Group>
                  </Col>
                )}
              </Row>
            </Form>
          </Modal.Body>
          <Modal.Footer style={{ borderTop: "1px solid #E2E8F0", padding: "16px 24px", backgroundColor: "#F8FAFC" }}>
            <Button
              variant="light"
              onClick={() => { handleModalClose(); setSalesMarketing(false); }}
              style={{ borderRadius: "8px", fontWeight: "600", padding: "10px 20px", color: "#64748B", border: "1px solid #E2E8F0" }}
            >
              Batal
            </Button>
            <Button
              onClick={submitMarketing}
              style={{ borderRadius: "8px", fontWeight: "600", padding: "10px 24px", backgroundColor: "#0EA5E9", border: "none", boxShadow: "0 4px 6px rgba(14, 165, 233, 0.2)", color: "white" }}
            >
              <i className="fas fa-save mr-2"></i> Simpan Data
            </Button>
          </Modal.Footer>
        </>
      </Modal>

      <Modal
        size="md"
        show={modalTambahAkses}
        onHide={() => {
          handleModalClose();
          setModalTambahAkses(false);
        }}
        centered
        contentClassName="luxury-modal"
        selectedUser={selectedUser}
      >
        <>
          <Modal.Header style={{ borderBottom: "1px solid #E2E8F0", padding: "20px 24px", backgroundColor: "#F8FAFC" }}>
            <Modal.Title style={{ color: "#1E293B", fontWeight: "700", fontSize: "18px", margin: 0, display: "flex", alignItems: "center", gap: "10px" }}>
              <div style={{ backgroundColor: "#FDF4FF", padding: "8px", borderRadius: "10px", color: "#C026D3", display: "flex" }}>
                <i className="fas fa-user-shield"></i>
              </div>
              Kelola Akses Marketing
            </Modal.Title>
            <button aria-label="Tutup dialog" type="button" className="close" onClick={() => { handleModalClose(); setModalTambahAkses(false); }} style={{ color: "#64748B", opacity: 1, fontSize: "24px" }}>&times;</button>
          </Modal.Header>
          <Modal.Body style={{ padding: "24px" }}>
            <Form>
              <Form.Group className="mb-4">
                <label style={{ color: "#475569", fontWeight: "600", fontSize: "14px", marginBottom: "8px" }}>Pilih Akses Baru</label>
                <div style={{ display: "flex", gap: "10px" }}>
                  <Select
                    classNamePrefix="react-select"
                    value={pilihAkses}
                    onChange={(value) => setPilihAkses(value)}
                    options={listAkses}
                    placeholder="Pilih Akses..."
                    styles={{
                      control: (base) => ({
                        ...base,
                        borderRadius: "10px",
                        borderColor: "#E2E8F0",
                        padding: "2px",
                        boxShadow: "none",
                        "&:hover": { borderColor: "#C026D3" }
                      }),
                      container: (base) => ({
                        ...base,
                        flex: 1
                      })
                    }}
                  />
                  <Button
                    onClick={submitTambahAksesMarketing}
                    style={{ borderRadius: "10px", fontWeight: "600", padding: "0 20px", backgroundColor: "#C026D3", border: "none", boxShadow: "0 4px 6px rgba(192, 38, 211, 0.2)", color: "white" }}
                  >
                    Tambah
                  </Button>
                </div>
              </Form.Group>
            </Form>

            <div style={{ marginTop: "24px" }}>
              <h5 style={{ color: "#1E293B", fontWeight: "700", fontSize: "16px", marginBottom: "16px", borderBottom: "1px solid #E2E8F0", paddingBottom: "12px" }}>
                Daftar Akses Saat Ini
              </h5>

              {!aksesUser || aksesUser.length === 0 ? (
                <div style={{ backgroundColor: "#FEF2F2", padding: "16px", borderRadius: "10px", color: "#EF4444", textAlign: "center", fontWeight: "600", fontSize: "14px" }}>
                  <i className="fas fa-exclamation-circle mr-2"></i> User ini belum memiliki akses.
                </div>
              ) : (
                <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
                  {aksesUser?.map((akses, index) => (
                    <div key={akses} style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "12px 16px", backgroundColor: "#F8FAFC", borderRadius: "10px", border: "1px solid #E2E8F0" }}>
                      <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
                        <span style={{ backgroundColor: "#E2E8F0", color: "#475569", width: "24px", height: "24px", display: "flex", alignItems: "center", justifyContent: "center", borderRadius: "50%", fontSize: "12px", fontWeight: "700" }}>
                          {index + 1}
                        </span>
                        <span style={{ color: "#1E293B", fontWeight: "600", textTransform: "capitalize" }}>
                          {akses}
                        </span>
                      </div>

                      <OverlayTrigger placement="top" overlay={<Tooltip>Hapus Akses</Tooltip>}>
                        <Button aria-label="Hapus Akses" title="Hapus Akses"
                          variant="light"
                          style={{
                            padding: "6px",
                            borderRadius: "8px",
                            backgroundColor: "#FEF2F2",
                            color: "#EF4444",
                            border: "none",
                            width: "32px",
                            height: "32px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            transition: "all 0.2s"
                          }}
                          onMouseEnter={(e) => {
                            e.currentTarget.style.backgroundColor = "#EF4444";
                            e.currentTarget.style.color = "#FFFFFF";
                          }}
                          onMouseLeave={(e) => {
                            e.currentTarget.style.backgroundColor = "#FEF2F2";
                            e.currentTarget.style.color = "#EF4444";
                          }}
                          onClick={() => {
                            Swal.fire({
                              icon: "warning",
                              title: `Hapus Akses ${akses}?`,
                              text: "Apakah anda yakin ingin menghapus akses ini?",
                              showCancelButton: true,
                              confirmButtonColor: "#EF4444",
                              cancelButtonColor: "#64748B",
                              confirmButtonText: "Ya, Hapus!",
                              cancelButtonText: "Batal"
                            }).then((result) => {
                              if (result.isConfirmed) {
                                hapusAksesMarketing({
                                  idMarketing: idMarketing,
                                  akses: akses,
                                }).then((response) => {
                                  if (response.status === 200) {
                                    Swal.fire({
                                      icon: "success",
                                      title: "Berhasil",
                                      text: response.data.message,
                                      showConfirmButton: false,
                                      timer: 1500,
                                    });
                                    handleModalClose();
                                    getAllMarketing(dispatch, { idClient: "" });
                                  } else {
                                    Swal.fire({
                                      icon: "error",
                                      title: "Gagal",
                                      text: response.data.message || "Terjadi kesalahan",
                                    });
                                  }
                                });
                              }
                            });
                          }}
                        >
                          <i className="fas fa-trash-alt"></i>
                        </Button>
                      </OverlayTrigger>
                    </div>
                  ))}
                </div>
              )}
            </div>
          </Modal.Body>
        </>
      </Modal>
    </>
  );
}
export default ListMarketing;
